import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { Minus, Plus, Trash2 } from "lucide-react";
import { useCart } from "../contexts/CartContext";
import { MEDIA } from "../lib/api";

export default function Cart() {
    const { cart, updateQty, removeItem, isGuest } = useCart();
    const navigate = useNavigate();

    const fmt = (n) => `${(n || 0).toFixed(2)} RON`;

    return (
        <div className="container-x py-10" data-testid="cart-page">
            <h1 className="font-heading text-4xl mb-2">Coșul tău</h1>
            {isGuest && (cart.items || []).length > 0 && (
                <p className="text-sm text-muted-foreground mb-6">
                    Comanzi ca vizitator. <button onClick={() => navigate("/login?next=/cos")} className="text-primary underline">Autentifică-te</button> pentru beneficii de client (discount-uri, istoric comenzi).
                </p>
            )}
            {(cart.items || []).length === 0 ? (
                <div className="text-center py-16 card-soft">
                    <p className="text-muted-foreground mb-4">Coșul este gol</p>
                    <Link to="/magazin" className="btn-primary">Vezi produsele</Link>
                </div>
            ) : (
                <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 mt-4">
                    <div className="lg:col-span-2 space-y-3">
                        {cart.items.map((it, i) => (
                            <div key={i} className="flex gap-4 card-soft p-4" data-testid={`cart-row-${i}`}>
                                <div className="w-24 h-24 bg-muted rounded-lg flex-shrink-0 overflow-hidden">
                                    {it.image && <img src={MEDIA(it.image)} alt="" className="w-full h-full object-cover" />}
                                </div>
                                <div className="flex-1">
                                    <div className="font-medium">{it.name}</div>
                                    <div className="text-sm text-primary mt-1">{fmt(it.unit_price)}</div>
                                    <div className="flex items-center gap-3 mt-3">
                                        <div className="flex items-center border border-border rounded-lg">
                                            <button className="px-2 py-1 hover:bg-muted rounded-l-lg" onClick={() => updateQty(it.product_id, it.package_id, it.quantity - 1)}><Minus className="h-3 w-3" /></button>
                                            <span className="px-3">{it.quantity}</span>
                                            <button className="px-2 py-1 hover:bg-muted rounded-r-lg" onClick={() => updateQty(it.product_id, it.package_id, it.quantity + 1)}><Plus className="h-3 w-3" /></button>
                                        </div>
                                        <button onClick={() => removeItem(it.product_id, it.package_id)} className="text-destructive"><Trash2 className="h-4 w-4" /></button>
                                    </div>
                                </div>
                                <div className="font-heading text-lg">{fmt(it.unit_price * it.quantity)}</div>
                            </div>
                        ))}
                    </div>
                    <div className="card-soft p-6 h-fit">
                        <h3 className="font-heading text-xl mb-4">Sumar</h3>
                        <div className="space-y-2 text-sm mb-4">
                            <div className="flex justify-between"><span className="text-muted-foreground">Subtotal</span><span>{fmt(cart.subtotal)}</span></div>
                            {cart.user_discount_amount > 0 && <div className="flex justify-between text-primary"><span>Discount cont</span><span>-{fmt(cart.user_discount_amount)}</span></div>}
                        </div>
                        <div className="flex justify-between font-heading text-xl mb-4"><span>Total</span><span className="text-primary">{fmt(cart.total)}</span></div>
                        <button onClick={() => navigate("/checkout")} className="btn-primary w-full" data-testid="cart-page-checkout">Finalizează comanda</button>
                    </div>
                </div>
            )}
        </div>
    );
}
